import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setUserProfile } from '../userProfile/userProfileSlice';
import { StoreType } from '../../../types/storeType';

interface StateType {
  activeStore: StoreType | null;
  stores: Array<StoreType>;
  hasStore: Boolean;
}

const initialState: StateType = {
  activeStore: null,
  stores: [],
  hasStore: false,
};

const userStoresSlice = createSlice({
  name: 'userStores',
  initialState,
  reducers: {
    setUserStores: (state, action: PayloadAction<StoreType[]>) => {
      state = {
        activeStore: action.payload[0] || null,
        stores: action.payload || [],
        hasStore: action.payload.length > 0,
      };
    },
    setAsActiveStore: (
      state,
      action: PayloadAction<{
        store_id: StoreType['id'];
      }>
    ) => {
      const target = state.stores.find(
        ({ id }) => id === action.payload.store_id
      );
      if (target) state.activeStore = target;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setUserProfile, (state, action) => {
      return (state = {
        activeStore: action.payload.stores?.[0] || null,
        stores: action.payload.stores || [],
        hasStore: action.payload.stores?.length > 0,
      });
    });
  },
});

export default userStoresSlice.reducer;
export const { setAsActiveStore, setUserStores } = userStoresSlice.actions;
